import { render, staticRenderFns } from "./create.vue?vue&type=template&id=4f3f0797&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=4f3f0797&prod&scoped=true&lang=scss"
import style1 from "./create.vue?vue&type=style&index=1&id=4f3f0797&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f0797",
  null
  
)

export default component.exports